export const PRODUCT_IMAGES = {
  RAY: require('../assets/img/ray_small.png'),
  ADAPTER: require('../assets/img/adapter.png'),
  SUBSCRIPTION: require('../assets/img/subscription.png')
};

export const CHARGEBEE_SUBSCRIPTION_PLANS = [
  { id: 'gofar_unlimited_bi_yearly', currency: 'AUD', price: 21600, name: '2 Year Unlimited Plan' },
  { id: 'gofar_unlimited_yearly_1', currency: 'AUD', price: 13200, name: 'Annual Unlimited Plan' },
  { id: 'gofar_unlimited_yearly', currency: 'AUD', price: 13200, name: 'Annual Unlimited Plan' },
  { id: 'gofar_unlimited_monthly_1', currency: 'AUD', price: 1500, name: 'Monthly Unlimited Plan' },
  { id: 'gofar_unlimited_monthly', currency: 'AUD', price: 1499, name: 'Monthly Unlimited Plan' },
  { id: 'gofar_basic', currency: 'AUD', price: 0, name: 'Basic Plan' },
  { id: 'cheap_gofar_unlimited_yearly', currency: 'AUD', price: 50, name: 'Annual Unlimited Plan [Test]' }
];

export const CHARGEBEE_ADD_ONS = [
  { id: 'gofar_adapter_1', currency: 'AUD', price: 10000, name: 'GOFAR Adapter', imageUrl: PRODUCT_IMAGES.ADAPTER },
  { id: 'gofar_ray_1', currency: 'AUD', price: 4900, name: 'GOFAR Ray', imageUrl: PRODUCT_IMAGES.RAY },
  { id: 'gofar_ray', currency: 'AUD', price: 4900, name: 'GOFAR Ray', imageUrl: PRODUCT_IMAGES.RAY },
];

export const MAX_ALLOWED_QUANTITY = 9;

export const SHIPPING_OPTIONS = {
  AUSTRALIA_POST: {
    id: 'shipping-australia-post',
    name: 'AusPost Snail Mail',
    delivery_days: '6-10',
    has_tracking: false,
    price: 0,
    currency: 'AUD'
  },
  AUSTRALIA_POST_EXPRESS: {
    id: 'shipping-australia-post-express',
    name: 'Priority Business',
    delivery_days: '2-4',
    has_tracking: true,
    price: 0,
    currency: 'AUD'
  },
  INTERNATIONAL_SHIPPING: {
    id: 'international-shipping-with-tracking',
    name: 'International Shipping',
    delivery_days: '2-4',
    has_tracking: true,
    price: 1500,
    currency: 'AUD'
  },
  FREE_INTERNATIONAL_SHIPPING: {
    id: 'free-international-shipping-with-tracking',
    name: 'International Shipping',
    delivery_days: '2-4',
    has_tracking: true,
    price: 0,
    currency: 'AUD'
  }
};

export const COUNTRY_SETTINGS = {
  AU: {
    currencyCode: 'AUD',
    currencySymbol: '$',
    exchangeRate: 1,
    shippingOptions: [SHIPPING_OPTIONS.AUSTRALIA_POST_EXPRESS, SHIPPING_OPTIONS.AUSTRALIA_POST]
  },
  CA: {
    currencyCode: 'CAD',
    currencySymbol: '$',
    exchangeRate: 1,
    // as part of promotion, we are providing free shipping for canadian orders
    shippingOptions: [SHIPPING_OPTIONS.FREE_INTERNATIONAL_SHIPPING]
  },
  US: {
    currencyCode: 'USD',
    currencySymbol: '$',
    exchangeRate: 0.7,
    shippingOptions: [SHIPPING_OPTIONS.INTERNATIONAL_SHIPPING]
  },
  DEFAULT: {
    currencyCode: 'AUD',
    currencySymbol: '$',
    exchangeRate: 1,
    shippingOptions: [SHIPPING_OPTIONS.INTERNATIONAL_SHIPPING]
  }
};
